import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const MEASUREMENT_UNITS = [
  "",
  "pH",
  "°C",
  "%",
  "µS/cm",
  "mg/kg",
  "mg/L",
  "m",
  "ppm",
  "g/L",
];

const CropVariableForm = ({
  onSubmit,
  type = "create",
  initialValues = {},
}) => {
  const defaultState = {
    name: "",
    measurementUnit: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const payload = {
      ...form,
      createdAt: form.createdAt || new Date().toISOString().slice(0, 10),
    };
    onSubmit && onSubmit(payload);
  };

  const handleReset = () => setForm({ ...defaultState, ...initialValues });

  return (
    <Grid rowGap="15px" columnGap="15px" padding="20px">
      <Grid gap="15px" templateColumns={{ base: "1fr", large: "2fr 2fr" }}>
        <TextField
          name="name"
          label={strings.fields.name.label}
          value={form.name || ""}
          onChange={handleChange}
        />
        <SelectField
          name="measurementUnit"
          label={strings.fields.measurementUnit.label}
          value={form.measurementUnit || ""}
          onChange={handleChange}
        >
          {MEASUREMENT_UNITS.map((unit) => (
            <option key={unit} value={unit}>
              {unit || "--"}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Flex justifyContent="end">
        <Button children={strings.fields.buttons.reset} onClick={handleReset} />
        <Button
          children={
            type === "create"
              ? strings.fields.buttons.create
              : strings.fields.buttons.save
          }
          onClick={handleSubmit}
          variation="primary"
        />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      name: { label: "Nombre" },
      measurementUnit: { label: "Unidad de Medida" },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
      },
    },
  },
});

export default CropVariableForm;
